"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */

/*
query TooltipsDataLoaderQuery(
  $artistSlugs: [String!]
  $geneSlugs: [String!]
) {
  artists(slugs: $artistSlugs) {
    slug
    internalID
    ...ArtistToolTip_artist
    ...MarketDataSummary_artist
    ...FollowArtistButton_artist
    id
  }
  genes(slugs: $geneSlugs) {
    slug
    internalID
    ...GeneToolTip_gene
    ...FollowGeneButton_gene
    id
  }
}

fragment ArtistToolTip_artist on Artist {
  name
  slug
  internalID
  formatted_nationality_and_birthday: formattedNationalityAndBirthday
  href
  blurb
  carousel {
    images {
      resized(height: 200) {
        url
        width
        height
      }
    }
  }
  genes {
    name
    id
  }
}

fragment FollowArtistButton_artist on Artist {
  id
  internalID
  name
  is_followed: isFollowed
  counts {
    follows
  }
}

fragment FollowGeneButton_gene on Gene {
  id
  internalID
  is_followed: isFollowed
}

fragment GeneToolTip_gene on Gene {
  description
  href
  slug
  internalID
  image {
    url(version: "tall")
  }
  name
}

fragment MarketDataSummary_artist on Artist {
  internalID
  collections
  highlights {
    partnersConnection(first: 10, displayOnPartnerProfile: true, representedBy: true, partnerCategory: ["blue-chip", "top-established", "top-emerging"]) {
      edges {
        node {
          categories {
            slug
            id
          }
          id
        }
        id
      }
    }
  }
  auctionResultsConnection(recordsTrusted: true, first: 1, sort: PRICE_AND_DATE_DESC) {
    edges {
      node {
        price_realized: priceRealized {
          display(format: "0a")
        }
        id
      }
    }
  }
}
*/
var node = function () {
  var v0 = [{
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "artistSlugs",
    "type": "[String!]"
  }, {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "geneSlugs",
    "type": "[String!]"
  }],
      v1 = [{
    "kind": "Variable",
    "name": "slugs",
    "variableName": "artistSlugs"
  }],
      v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  },
      v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalID",
    "storageKey": null
  },
      v4 = [{
    "kind": "Variable",
    "name": "slugs",
    "variableName": "geneSlugs"
  }],
      v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
      v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "href",
    "storageKey": null
  },
      v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
      v8 = {
    "alias": "is_followed",
    "args": null,
    "kind": "ScalarField",
    "name": "isFollowed",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Fragment",
      "metadata": null,
      "name": "TooltipsDataLoaderQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artist",
        "kind": "LinkedField",
        "name": "artists",
        "plural": true,
        "selections": [v2
        /*: any*/
        , v3
        /*: any*/
        , {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ArtistToolTip_artist"
        }, {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MarketDataSummary_artist"
        }, {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FollowArtistButton_artist"
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": v4
        /*: any*/
        ,
        "concreteType": "Gene",
        "kind": "LinkedField",
        "name": "genes",
        "plural": true,
        "selections": [v2
        /*: any*/
        , v3
        /*: any*/
        , {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GeneToolTip_gene"
        }, {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FollowGeneButton_gene"
        }],
        "storageKey": null
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Operation",
      "name": "TooltipsDataLoaderQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artist",
        "kind": "LinkedField",
        "name": "artists",
        "plural": true,
        "selections": [v2
        /*: any*/
        , v3
        /*: any*/
        , v5
        /*: any*/
        , {
          "alias": "formatted_nationality_and_birthday",
          "args": null,
          "kind": "ScalarField",
          "name": "formattedNationalityAndBirthday",
          "storageKey": null
        }, v6
        /*: any*/
        , {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blurb",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "ArtistCarousel",
          "kind": "LinkedField",
          "name": "carousel",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "images",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": [{
                "kind": "Literal",
                "name": "height",
                "value": 200
              }],
              "concreteType": "ResizedImageUrl",
              "kind": "LinkedField",
              "name": "resized",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              }, {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              }],
              "storageKey": "resized(height:200)"
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "Gene",
          "kind": "LinkedField",
          "name": "genes",
          "plural": true,
          "selections": [v5
          /*: any*/
          , v7
          /*: any*/
          ],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "collections",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "ArtistHighlights",
          "kind": "LinkedField",
          "name": "highlights",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "displayOnPartnerProfile",
              "value": true
            }, {
              "kind": "Literal",
              "name": "first",
              "value": 10
            }, {
              "kind": "Literal",
              "name": "partnerCategory",
              "value": ["blue-chip", "top-established", "top-emerging"]
            }, {
              "kind": "Literal",
              "name": "representedBy",
              "value": true
            }],
            "concreteType": "PartnerArtistConnection",
            "kind": "LinkedField",
            "name": "partnersConnection",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "PartnerArtistEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "Partner",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "PartnerCategory",
                  "kind": "LinkedField",
                  "name": "categories",
                  "plural": true,
                  "selections": [v2
                  /*: any*/
                  , v7
                  /*: any*/
                  ],
                  "storageKey": null
                }, v7
                /*: any*/
                ],
                "storageKey": null
              }, v7
              /*: any*/
              ],
              "storageKey": null
            }],
            "storageKey": "partnersConnection(displayOnPartnerProfile:true,first:10,partnerCategory:[\"blue-chip\",\"top-established\",\"top-emerging\"],representedBy:true)"
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 1
          }, {
            "kind": "Literal",
            "name": "recordsTrusted",
            "value": true
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "PRICE_AND_DATE_DESC"
          }],
          "concreteType": "AuctionResultConnection",
          "kind": "LinkedField",
          "name": "auctionResultsConnection",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "AuctionResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "AuctionResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [{
                "alias": "price_realized",
                "args": null,
                "concreteType": "AuctionResultPriceRealized",
                "kind": "LinkedField",
                "name": "priceRealized",
                "plural": false,
                "selections": [{
                  "alias": null,
                  "args": [{
                    "kind": "Literal",
                    "name": "format",
                    "value": "0a"
                  }],
                  "kind": "ScalarField",
                  "name": "display",
                  "storageKey": "display(format:\"0a\")"
                }],
                "storageKey": null
              }, v7
              /*: any*/
              ],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": "auctionResultsConnection(first:1,recordsTrusted:true,sort:\"PRICE_AND_DATE_DESC\")"
        }, v7
        /*: any*/
        , v8
        /*: any*/
        , {
          "alias": null,
          "args": null,
          "concreteType": "ArtistCounts",
          "kind": "LinkedField",
          "name": "counts",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "follows",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": v4
        /*: any*/
        ,
        "concreteType": "Gene",
        "kind": "LinkedField",
        "name": "genes",
        "plural": true,
        "selections": [v2
        /*: any*/
        , v3
        /*: any*/
        , {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }, v6
        /*: any*/
        , {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "version",
              "value": "tall"
            }],
            "kind": "ScalarField",
            "name": "url",
            "storageKey": "url(version:\"tall\")"
          }],
          "storageKey": null
        }, v5
        /*: any*/
        , v7
        /*: any*/
        , v8
        /*: any*/
        ],
        "storageKey": null
      }]
    },
    "params": {
      "id": null,
      "metadata": {},
      "name": "TooltipsDataLoaderQuery",
      "operationKind": "query",
      "text": "query TooltipsDataLoaderQuery(\n  $artistSlugs: [String!]\n  $geneSlugs: [String!]\n) {\n  artists(slugs: $artistSlugs) {\n    slug\n    internalID\n    ...ArtistToolTip_artist\n    ...MarketDataSummary_artist\n    ...FollowArtistButton_artist\n    id\n  }\n  genes(slugs: $geneSlugs) {\n    slug\n    internalID\n    ...GeneToolTip_gene\n    ...FollowGeneButton_gene\n    id\n  }\n}\n\nfragment ArtistToolTip_artist on Artist {\n  name\n  slug\n  internalID\n  formatted_nationality_and_birthday: formattedNationalityAndBirthday\n  href\n  blurb\n  carousel {\n    images {\n      resized(height: 200) {\n        url\n        width\n        height\n      }\n    }\n  }\n  genes {\n    name\n    id\n  }\n}\n\nfragment FollowArtistButton_artist on Artist {\n  id\n  internalID\n  name\n  is_followed: isFollowed\n  counts {\n    follows\n  }\n}\n\nfragment FollowGeneButton_gene on Gene {\n  id\n  internalID\n  is_followed: isFollowed\n}\n\nfragment GeneToolTip_gene on Gene {\n  description\n  href\n  slug\n  internalID\n  image {\n    url(version: \"tall\")\n  }\n  name\n}\n\nfragment MarketDataSummary_artist on Artist {\n  internalID\n  collections\n  highlights {\n    partnersConnection(first: 10, displayOnPartnerProfile: true, representedBy: true, partnerCategory: [\"blue-chip\", \"top-established\", \"top-emerging\"]) {\n      edges {\n        node {\n          categories {\n            slug\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  auctionResultsConnection(recordsTrusted: true, first: 1, sort: PRICE_AND_DATE_DESC) {\n    edges {\n      node {\n        price_realized: priceRealized {\n          display(format: \"0a\")\n        }\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();

node.hash = '76f8dc1dd83c0eba38b7b6dc5579ec75';
var _default = node;
exports.default = _default;
//# sourceMappingURL=TooltipsDataLoaderQuery.graphql.js.map